import { Box, Divider, Grid, Typography } from "@material-ui/core";
import React, { useState } from "react";
import { addContactV2Style } from "./AddContactV2Style";
import BasicInput from "../custom/BasicInput";
import { renderEachCustomField } from "./RenderEachCustomField";
import { CustomFieldType } from "../../constants/CoreConstants";
import { useSelector } from "react-redux";
import BasicSelectWithSearch from "../custom/BasicSelectWithSearch";

const CommercialContactAdditionalInfoTab = ({
  additionalInfoRef,
  customFields,
  customFieldsData,
  handleCustomFieldChange,
  handleInputField,
  commercialContactForm,
}) => {
  const { insuranceCompanyOptions, PolicyOptions } = useSelector(
    (state) => state.addContactOptionReducer
  );
  const classes = addContactV2Style();
  const [selectedInsuranceCompany, setSelectedInsuranceCompany] = useState("");
  const [selectedPolicy, setSelectedPolicy] = useState("");
  const DEFAULT_CUSTOM_FIELD = {
    INSURANCE_COMPANY: "[[insurance_company]]",
    POLICY_TYPE: "[[policy_type_(l.o.b)]]",
  };

  const handleSelectChange = (e, data, index) => {
    const value = e.target.value;
    if (data.personalize_tag === DEFAULT_CUSTOM_FIELD.INSURANCE_COMPANY) {
      setSelectedInsuranceCompany(value);
    } else if (data.personalize_tag === DEFAULT_CUSTOM_FIELD.POLICY_TYPE) {
      setSelectedPolicy(value);
    }
    handleCustomFieldChange(value, index, data.id, data?.max_length);
  };

  return (
    <Grid container spacing={2} style={{ paddingInline: 5, marginBottom: 24 }}>
      <Grid item xs={12}>
        <div style={{ width: "100%" }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div
              ref={additionalInfoRef}
              data-section="Additional Info"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                paddingRight: "10px",
              }}
            >
              <Typography variant="body2" className={classes.titleStyle}>
                Additional Info
              </Typography>
            </div>

            <div style={{ width: "100%" }}>
              <Divider />
            </div>
          </div>
        </div>
      </Grid>

      { customFields &&
        Array.isArray(customFields) && 
        customFields.length > 0 && (
          <div style={{ 
        width: "100%", 
        border: "1px solid #ccc",
        borderRadius: "8px",
        padding: "8px",
        margin: '8px'
        }}>
        <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          columnGap: 20,
          padding: "8px",
          width: "100%",
        }}
        className="main-add-contact-modal main-add-contact-modal-v2"
      >
        {
          customFields.map((each, index) => {
            if (
              each.type_id === CustomFieldType.SELECT &&
              (each.personalize_tag ===
                DEFAULT_CUSTOM_FIELD.INSURANCE_COMPANY ||
                each.personalize_tag === DEFAULT_CUSTOM_FIELD.POLICY_TYPE)
            ) {
              return (
                <div key={index} style={{ width: "100%", marginTop: "8px" }}>
                  <Typography
                    variant="body1"
                    style={{
                      left: "0",
                      marginBottom: '5px',
                      position: "relative",
                      height: "auto",
                      fontWeight: "600",
                      color: "var(--dark_blue)",
                      fontSize: "14px",
                    }}
                  >
                    {each?.title}
                  </Typography>
                  <BasicSelectWithSearch
                    fullWidth
                    options={
                      each.personalize_tag ===
                      DEFAULT_CUSTOM_FIELD.INSURANCE_COMPANY
                        ? insuranceCompanyOptions
                        : PolicyOptions
                    }
                    mapping={{
                      label:
                        each.personalize_tag ===
                        DEFAULT_CUSTOM_FIELD.INSURANCE_COMPANY
                          ? "company_name"
                          : "title",
                      value:
                        each.personalize_tag ===
                        DEFAULT_CUSTOM_FIELD.INSURANCE_COMPANY
                          ? "company_name"
                          : "title",
                    }}
                    defaultText={
                      each.personalize_tag ===
                      DEFAULT_CUSTOM_FIELD.INSURANCE_COMPANY
                        ? "Select insurance company"
                        : "Select policy type"
                    }
                    placeholderText={
                      each.personalize_tag ===
                      DEFAULT_CUSTOM_FIELD.INSURANCE_COMPANY
                        ? "Search for insurance company..."
                        : "Search for policy type..."
                    }
                    onChange={(e) => handleSelectChange(e, each, index)}
                    value={
                      each.personalize_tag ===
                      DEFAULT_CUSTOM_FIELD.INSURANCE_COMPANY
                        ? selectedInsuranceCompany
                        : selectedPolicy
                    }
                  />
                </div>
              );
            } else {
              return renderEachCustomField(
                each,
                index,
                handleCustomFieldChange,
                customFieldsData
              );
            }
          })}
      </Box>
          </div>
    )}

      <Grid item xs={12}>
        <BasicInput
          name="commercialComments"
          fullWidth
          placeholder="Comments"
          multiline
          rows={8}
          inputProps={{
            style: {
              minHeight: "150px",
            },
          }}
          onChange={(e) =>
                handleInputField("note", e.target.value)
              }
          value={commercialContactForm.note}
        />
      </Grid>
    </Grid>
  );
};

export default CommercialContactAdditionalInfoTab;
